import { usePdp } from '@context/PdpContext';
import { useTranslation } from 'next-i18next';
import { getStockLevel } from '@utils/inventory/getStockLevel';

const useDeliveryStockLevel = () => {
  const { t } = useTranslation('pdp');
  const { selectedVariant } = usePdp();

  const availableToSell = selectedVariant?.inventoryAggregated?.availableToSell;
  const stockLevel = getStockLevel(availableToSell) || null;

  const getStockLevelMessage = () => {
    if (stockLevel === 'outOfStock') {
      return t('product.out.of.stock');
    }
    if (stockLevel === 'low') {
      return t('product.low.stock.message', {
        stock: availableToSell,
      });
    }
    if (stockLevel === 'medium' || stockLevel === 'high') {
      return t('product.in.stock');
    }
  };

  const stockLevelMessage = getStockLevelMessage() || null;

  return {
    stockLevel,
    stockLevelMessage,
  };
};

export default useDeliveryStockLevel;
